import * as React from "react";
import { match } from "react-router-dom";
import {
  Select,
  FormControl,
  MenuItem,
  FormHelperText,
} from "@material-ui/core";
import TopBar from "./Ops.ApplicationStatusMessages.GeneralTopBar";
import AllApplicationStatusMessagesContainer from "app/components/AppComponents/ApplicationsStatusMessages/AllApplicationStatusMessagesContainer";

const Levels = [
  {
    value: "true",
    label: "Show active status messages",
  },
  {
    value: "false",
    label: "Show all status messages",
  },
];

type Props = {
  match: match<{ ref: string }>;
  setHeader: (data: { title: string; description: string }) => void;
  data: any;
};

type State = {
  active: boolean;
};

export default class Active extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      active: true,
    };
  }

  componentDidMount() {
    this.props.setHeader({
      title: "Ops > Application status messages",
      description: "Status messages",
    });
  }

  strToBool = (str: string) => {
    return str.toLowerCase() === "true";
  };

  onActiveChange = (value: string) => {
    this.setState({
      active: this.strToBool(value),
    });
  };

  render() {
    return (
      <>
        <TopBar />
        <section className="padded">
          <div
            style={{
              paddingBottom: "20px",
            }}
          >
            <FormControl>
              <Select
                style={{ width: "300px", padding: "10px" }}
                value={this.state.active}
                onChange={(event) => this.onActiveChange(event.target.value)}
                inputProps={{
                  name: "levelInput",
                  id: "level",
                }}
              >
                {Levels.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>
                Choose whether to only display status messages that are
                currently active, or all historical status messages.
              </FormHelperText>
            </FormControl>
          </div>
          <AllApplicationStatusMessagesContainer
            name={"ops.application_status_messages.active"}
            active={this.state.active}
          />
        </section>
      </>
    );
  }
}
